import type { OPLayoutComponent, OPLayoutPanel } from "./types"

function sanitizeKey(value: string): string {
  return value.trim().toLowerCase().replace(/\s+/g, "-")
}

export function generateStablePanels(components: readonly OPLayoutComponent[]): OPLayoutPanel[] {
  const occurrences: Record<string, number> = {}

  return components.map((component) => {
    const count = occurrences[component.component] ?? 0
    occurrences[component.component] = count + 1

    const baseId = sanitizeKey(component.component)
    const panelId = `op-layout-engine-${baseId}-${count}`

    return {
      component,
      panelId,
      instanceIndex: count,
    }
  })
}

export function limitComponentsByMaxPanels(
  components: readonly OPLayoutComponent[],
  maxPanels: number | undefined,
): readonly OPLayoutComponent[] {
  if (maxPanels === undefined || components.length <= maxPanels) {
    return components
  }

  return components.slice(0, maxPanels)
}
